import BaseModel from './BaseModel';
import Review from './Review';

export default class ReviewCriteria extends BaseModel {
  constructor(data = {}) {
    super(ReviewCriteria, data);
    this.id = data.id;
    this.review = data.review ? new Review(data.review) : null;
    this.description = data.description;
    this.criteriaType = data.criteriaType;
  }

  creationData() {
    return {
      id: this.id,
      review: this.review.id,
      description: this.description,
      criteriaType: this.criteriaType,
    };
  }
}
